var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.$route.params.id ? _c('div', {
    staticClass: "d-flex flex-wrap justify-content-between align-items-center mb-2 p-1 bg-white rounded shadow-sm border"
  }, [_c('div', {
    staticClass: "d-flex align-items-center mb-50 mb-sm-0"
  }, [_c('b-badge', {
    staticClass: "mr-1 py-50 px-1 font-weight-bolder",
    attrs: {
      "variant": "light-primary"
    }
  }, [_vm._v(" EDIÇÃO ")]), _c('span', {
    staticClass: "text-muted small"
  }, [_vm._v(" Navegue clicando diretamente nas etapas à esquerda ou use o atalho rápido: ")])], 1), _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": _vm.irParaCronograma
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "CalendarIcon"
    }
  }), _vm._v(" Ir para Desafios & Cronograma ")], 1)], 1) : _vm._e(), _c('form-wizard', {
    ref: "wizard",
    staticClass: "wizard-vertical mb-3",
    attrs: {
      "color": "#7367F0",
      "title": null,
      "subtitle": null,
      "layout": "vertical",
      "finish-button-text": "Finalizar",
      "back-button-text": "Anterior",
      "next-button-text": "Próximo"
    },
    on: {
      "on-complete": _vm.formSubmitted
    }
  }, [_c('tab-content', {
    attrs: {
      "title": "Dados da Escola"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Dados da Escola ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Insira os dados da Escola ")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome da Escola",
      "label-for": "v-username"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-username",
      "placeholder": "Insira o nome aqui"
    },
    model: {
      value: _vm.form.name,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "name", $$v);
      },
      expression: "form.name"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "E-mail",
      "label-for": "v-email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-email",
      "type": "email",
      "placeholder": "exemplo@email.com"
    },
    model: {
      value: _vm.form.email,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Telefone",
      "label-for": "v-username"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-username",
      "placeholder": "Insira o número aqui"
    },
    model: {
      value: _vm.form.telephone,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "telephone", $$v);
      },
      expression: "form.telephone"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-for": "v-greId",
      "label": "Gerência Regional de Educação (GRE)"
    }
  }, [_c('v-select', {
    attrs: {
      "id": "greId",
      "dir": _vm.$store.state.appConfig.isRTL ? 'rtl' : 'ltr',
      "selectable": function selectable(option) {
        return option.value != null;
      },
      "options": _vm.greOptions,
      "label": "text"
    },
    scopedSlots: _vm._u([{
      key: "no-options",
      fn: function fn(_ref) {
        var searching = _ref.searching;
        return [searching ? _c('span', [_vm._v("Nenhum resultado encontrado.")]) : _c('span', [_vm._v("Ops! Lista vazia.")])];
      }
    }]),
    model: {
      value: _vm.form.greId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "greId", $$v);
      },
      expression: "form.greId"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Ponto de Coleta"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.existePontoColeta,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "existePontoColeta", $$v);
      },
      expression: "form.existePontoColeta"
    }
  }, [_vm._v(" Escola possui ponto de coleta ")])], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Diretoria"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Diretoria ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Insira as informações do Diretor")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome do Diretor",
      "label-for": "v-first-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-first-name",
      "placeholder": ""
    },
    model: {
      value: _vm.form.nameDirector,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "nameDirector", $$v);
      },
      expression: "form.nameDirector"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "E-mail",
      "label-for": "v-last-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-last-name",
      "placeholder": ""
    },
    model: {
      value: _vm.form.emailDirector,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "emailDirector", $$v);
      },
      expression: "form.emailDirector"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CPF",
      "label-for": "v-last-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-last-name",
      "placeholder": ""
    },
    model: {
      value: _vm.form.cpfDirector,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cpfDirector", $$v);
      },
      expression: "form.cpfDirector"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Celular",
      "label-for": "v-last-name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-last-name",
      "placeholder": ""
    },
    model: {
      value: _vm.form.cellPhoneDirector,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "cellPhoneDirector", $$v);
      },
      expression: "form.cellPhoneDirector"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Endereço"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Endereço ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Insira os dados sobre localização")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Endereço",
      "label-for": "v-address"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-address",
      "placeholder": ""
    },
    model: {
      value: _vm.form.address,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "address", $$v);
      },
      expression: "form.address"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Bairro",
      "label-for": "v-landmark"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-landmark",
      "placeholder": ""
    },
    model: {
      value: _vm.form.neighborhood,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "neighborhood", $$v);
      },
      expression: "form.neighborhood"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CEP",
      "label-for": ""
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-pincode",
      "placeholder": ""
    },
    model: {
      value: _vm.form.postalCode,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "postalCode", $$v);
      },
      expression: "form.postalCode"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cidade",
      "label-for": "v-city"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "v-city",
      "placeholder": ""
    },
    model: {
      value: _vm.form.city,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "city", $$v);
      },
      expression: "form.city"
    }
  })], 1)], 1)], 1)], 1), _c('tab-content', {
    attrs: {
      "title": "Desafios & Cronograma"
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v(" Controle e Cronograma de Desafios ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Configure a ativação e os períodos em que os desafios ficarão disponíveis para os alunos no aplicativo mobile.")])])], 1), _c('b-row', {
    staticClass: "mb-2 p-1 border rounded bg-light"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-between"
  }, [_c('div', [_c('h6', {
    staticClass: "text-primary font-weight-bold mb-25"
  }, [_vm._v(" Desafio: Coleta e Reciclagem ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Libera a execução da etapa de pesagem e descarte de recicláveis no aplicativo.")])]), _c('b-form-checkbox', {
    staticClass: "custom-control-primary",
    attrs: {
      "switch": ""
    },
    model: {
      value: _vm.form.coletaAtiva,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "coletaAtiva", $$v);
      },
      expression: "form.coletaAtiva"
    }
  }, [_vm._v(" " + _vm._s(_vm.form.coletaAtiva ? 'Desafio Ativado' : 'Desafio Desativado') + " ")])], 1)]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data de Início da Coleta",
      "label-for": "coletaDataInicio"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "coletaDataInicio",
      "config": _vm.configFlatPickr,
      "placeholder": "Ex: 01/10/2026"
    },
    model: {
      value: _vm.form.coletaDataInicio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "coletaDataInicio", $$v);
      },
      expression: "form.coletaDataInicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Data de Término da Coleta",
      "label-for": "coletaDataFim"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "coletaDataFim",
      "config": _vm.configFlatPickr,
      "placeholder": "Ex: 31/10/2026"
    },
    model: {
      value: _vm.form.coletaDataFim,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "coletaDataFim", $$v);
      },
      expression: "form.coletaDataFim"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    staticClass: "mt-1 mb-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('h6', {
    staticClass: "text-secondary font-weight-bold"
  }, [_vm._v(" Período dos Demais Desafios (Exibição no App Mobile) ")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Defina os prazos exibidos nos cards da tela inicial do aplicativo para esta escola.")])]), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Quiz - Início",
      "label-for": "quizDataInicio"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "quizDataInicio",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.quizDataInicio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "quizDataInicio", $$v);
      },
      expression: "form.quizDataInicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Quiz - Fim",
      "label-for": "quizDataFim"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "quizDataFim",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.quizDataFim,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "quizDataFim", $$v);
      },
      expression: "form.quizDataFim"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Patrulha - Início",
      "label-for": "patrulhaDataInicio"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "patrulhaDataInicio",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.patrulhaDataInicio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "patrulhaDataInicio", $$v);
      },
      expression: "form.patrulhaDataInicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Patrulha - Fim",
      "label-for": "patrulhaDataFim"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "patrulhaDataFim",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.patrulhaDataFim,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "patrulhaDataFim", $$v);
      },
      expression: "form.patrulhaDataFim"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Janela de Tanque - Início",
      "label-for": "janelaDataInicio"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "janelaDataInicio",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.janelaDataInicio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "janelaDataInicio", $$v);
      },
      expression: "form.janelaDataInicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Janela de Tanque - Fim",
      "label-for": "janelaDataFim"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "janelaDataFim",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.janelaDataFim,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "janelaDataFim", $$v);
      },
      expression: "form.janelaDataFim"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Arboturma - Início",
      "label-for": "arboturmaDataInicio"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "arboturmaDataInicio",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.arboturmaDataInicio,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "arboturmaDataInicio", $$v);
      },
      expression: "form.arboturmaDataInicio"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Arboturma - Fim",
      "label-for": "arboturmaDataFim"
    }
  }, [_c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "id": "arboturmaDataFim",
      "config": _vm.configFlatPickr
    },
    model: {
      value: _vm.form.arboturmaDataFim,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "arboturmaDataFim", $$v);
      },
      expression: "form.arboturmaDataFim"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }